import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";
import { isVersionUS } from "../services/versionService";

const nationalityOptionFirst = isVersionUS ? "USA" : "GBR";

export const useGetCountries = () => {
    const {
        isLoading, data: countries, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: ["countries"],
        queryFn: () => axiosManager.get$("/parent/api/countries").then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        keepPreviousData: true,
    });

    const countriesOptions = (countries || []).map((item) => ({
        value: item.countryCode,
        label: item.name,
        id: item.countryCode,
        key: item.countryCode,
    })).sort((a) => (a.id === nationalityOptionFirst ? -1 : 1));

    return {
        isLoading,
        isRefetching,
        countries: countries || [],
        countriesOptions,
        error,
        refetch,
    };
};
